var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":"","my-2":""}},[_c('v-flex',{attrs:{"lg4":""}},[_c('recent-users',{attrs:{"items":_vm.users}})],1),_c('v-flex',{attrs:{"lg8":""}},[_c('recent-posts',{attrs:{"items":_vm.posts}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }